import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CreditNoteModel } from '@shared/data-access/models';
import { Observable, filter, take } from 'rxjs';
import { CreditNoteAction } from '../actions';
import { CreditNoteReducer } from '../reducers';
import { CreditNoteSelector } from '../selectors';

@Injectable()
export class CreditNoteFacade {
  selectedItem$ = this._store.select(CreditNoteSelector.selectCreditNote);
  constructor(private _store: Store<CreditNoteReducer.DataState>) {}

  /**
   * Get @CreditNoteModel by id
   */
  getById(id: number): Observable<CreditNoteModel | null> {
    this._store.dispatch(CreditNoteAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<CreditNoteModel | null>;
  }
}
